import React, { useContext } from 'react'
import { Button } from '@/components/ui/button'
import { Heading4 } from '@/components/ui/typography'
import {
  FormBaseButtonContainer,
  FormBaseContainer,
  FormBaseErrorMessage,
  FormBaseFieldBlock,
  FormBaseFieldGroup,
  FormBaseFieldLabel,
  FormBaseRow,
} from 'components/Form/Form.styles'
import { Field, Form, FormikErrors, FormikProps, withFormik } from 'formik'

import { PermissionsEnum } from '../../../../../api/Identity/Types/PermissionsEnum'
import { ClientSubscriptionOverrideDto } from '../../../../../api/Trading-Accounts/Types/ClientSubscriptionOverrideDto'
import { AuthSessionContext } from '../../../../../utils/AuthContext'
import { FormSubmitValues } from '../../../../../utils/formValidation'
import { hasPermission } from '../../../../../utils/permissionsValidator'

export type ClientSubscriptionPriceOverrideFormValues = {
  id?: string
  subscriptionDetailId: string
  clientId: string
  amount: number
}
const ClientSubscriptionPriceOverrideFormUI = ({
  handleSubmit,
  isSubmitting,
  isValid,
  errors,
  onClose,
}: FormikProps<ClientSubscriptionPriceOverrideFormValues> & OuterProps) => {
  const [auth] = useContext(AuthSessionContext)
  const permissions = auth?.permissions || []
  const handleSave = (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault()
    handleSubmit()
  }

  return (
    <React.Fragment>
      <Heading4>Price Override</Heading4>
      <FormBaseContainer>
        <Form onSubmit={handleSave}>
          <FormBaseFieldBlock>
            <FormBaseRow>
              <FormBaseFieldLabel>Price Override</FormBaseFieldLabel>
              <FormBaseFieldGroup style={{ position: 'relative' }}>
                <Field
                  disabled={
                    !hasPermission(permissions, PermissionsEnum.CanUpdateSubscriptionOverrides)
                  }
                  name='amount'
                  type='number'
                />
                {errors.amount && (
                  <FormBaseErrorMessage
                    style={{
                      position: 'absolute',
                      top: 24,
                    }}
                  >
                    {errors.amount}
                  </FormBaseErrorMessage>
                )}
              </FormBaseFieldGroup>
            </FormBaseRow>
          </FormBaseFieldBlock>
          <FormBaseButtonContainer
            style={{ justifyContent: 'flex-end', marginTop: '2rem', gap: '1rem' }}
          >
            <Button disabled={isSubmitting} key='button' type='button' onClick={onClose}>
              Cancel
            </Button>
            <Button key='button' type='submit' disabled={!isValid}>
              Submit
            </Button>
          </FormBaseButtonContainer>
        </Form>
      </FormBaseContainer>
    </React.Fragment>
  )
}

interface OuterProps {
  data: ClientSubscriptionOverrideDto
  clientId: string
  onSubmit(values: FormSubmitValues<ClientSubscriptionPriceOverrideFormValues>): Promise<void>
  onClose: () => void
}

export const ClientSubscriptionPriceOverrideForm = withFormik<
  OuterProps,
  ClientSubscriptionPriceOverrideFormValues
>({
  mapPropsToValues: ({ data, clientId }) => {
    const existingOverride = data.id
    return {
      id: existingOverride ? data.id : undefined,
      clientId,
      amount: data.amount,
      subscriptionDetailId: existingOverride ? data.id : data.subscriptionDetailId,
    }
  },
  handleSubmit: async (values, { props }) => {
    await props.onSubmit({ ...values, amount: Number(values.amount) })
  },
  validate: (values) => {
    const errors: FormikErrors<ClientSubscriptionPriceOverrideFormValues> = {}
    if (values.amount < 0) {
      errors.amount = 'Amount must be greater or equal to 0.'
    }
    return errors
  },
})(ClientSubscriptionPriceOverrideFormUI)
